import * as React from 'react';
import type { SVGProps } from 'react';
// The Pesa Wise mark: three broken concentric rings in the brand blues.
// Sliced from the full brand lockup (cymetrica-pesawise-logo-colour.svg
// in this folder); colors are fixed brand colors, not currentColor.
export const SvgLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="114 251 1334 1334"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <g transform="matrix(9.14692,0,0,9.14692,-2732.44,-2740.77)">
      <path
        fill="rgb(22,76,255)"
        d="M384.097,472.916C343.891,472.916 311.181,440.206 311.181,400C311.181,378.876 320.333,358.808 336.29,344.941C338.409,343.099 341.624,343.324 343.467,345.444C345.31,347.565 345.084,350.778 342.964,352.621C329.23,364.554 321.354,381.823 321.354,400C321.354,434.596 349.501,462.742 384.097,462.742C418.692,462.742 446.838,434.596 446.838,400C446.838,365.404 418.692,337.259 384.097,337.259C375.777,337.259 367.698,338.859 360.084,342.016C357.489,343.091 354.513,341.86 353.437,339.265C352.36,336.669 353.592,333.693 356.188,332.617C365.043,328.946 374.433,327.084 384.097,327.084C424.303,327.084 457.012,359.794 457.012,400C457.012,440.206 424.303,472.916 384.097,472.916Z"
      />
      <path
        fill="rgb(0,82,233)"
        d="M384.097,452.837C354.962,452.837 331.26,429.135 331.26,400C331.26,370.866 354.962,347.163 384.097,347.163C406.336,347.163 426.325,361.22 433.838,382.142C435.892,387.862 436.934,393.87 436.934,400C436.934,402.81 434.656,405.087 431.847,405.087C429.037,405.087 426.76,402.81 426.76,400C426.76,395.046 425.919,390.194 424.262,385.581C418.196,368.687 402.056,357.337 384.097,357.337C360.572,357.337 341.434,376.476 341.434,400C341.434,423.524 360.572,442.663 384.097,442.663C386.906,442.663 389.184,444.94 389.184,447.75C389.184,450.56 386.906,452.837 384.097,452.837Z"
      />
      <path
        fill="rgb(0,73,111)"
        d="M384.097,432.759C366.033,432.759 351.338,418.063 351.338,400C351.338,381.937 366.033,367.242 384.097,367.242C386.906,367.242 389.184,369.519 389.184,372.329C389.184,375.138 386.906,377.416 384.097,377.416C371.644,377.416 361.512,387.547 361.512,400C361.512,412.453 371.644,422.585 384.097,422.585C396.55,422.585 406.681,412.453 406.681,400C406.681,397.19 408.958,394.913 411.768,394.913C414.577,394.913 416.854,397.19 416.854,400C416.854,418.063 402.159,432.759 384.097,432.759Z"
      />
    </g>
  </svg>
);
